import { ButtonVariants } from "ui";
import { ButtonSizes } from "ui/primitives";

export enum WIDGETS {
  Header = "header",
  Search = "search",
  Filter = "filter_and_sort",
  Slider = "slider",
  NestedSlider = "nested_slider",
  Brands = "brands",
  FilterPopup = "filter_pop_up",
  Footer = "footer",
  CompareWidget = "car_compare_widget",
  BannerWidget = "banner_widget"
}

export enum CarouselType {
  TabBar = "tab_bar",
  Chips = "chip",
}

export enum FilterListKeyType {
  BodyType = "body_type_filter_chip",
  Brand = "brand_filter",
  FuelFilter = "fuel_filter_chip",
  RangeSlider = "range_slider",
  PriceChip = "price_filter_chip",
  SeatingCapacity = "seating_capacity_filter_chip",
  transmissionType = "transmission_type_filter_chip",
  DashDivider = "dash_divider",
  FilterSubtitle = "filter_sub_title",
}

export enum FilterMapping {
  Brands = "brand_id",
  Price = "price",
  FuelType = "fuel",
  TransmissionType = "transmission",
  BodyType = "body",
  SeatingCapacity = "seating_capacity",
  Sort = "sort",
  Page = "page",
  Status = "status",
}

export type HeaderType = {
  widgetType: WIDGETS.Header;
  title: string;
  subtitle: string;
  image: string;
};

export type SearchType = {
  widgetType: WIDGETS.Search;
  placeholder: string;
  icon: string;
};

export enum Filters {
  Filter = "filter",
  Chip = "chip",
  Sort = "sort",
}

export type FilterListType = {
  type: Filters;
  icon?: string;
  text?: string;
  key?: string;
};

export type FilterType = {
  widgetType: WIDGETS.Filter;
  list: FilterListType[];
};

export type SliderListType = {
  redirectionUrl: string;
  subtitle: string;
  title: string;
  image: string;
  expectedLaunchDate?: string;
  inventoryId: number;
  modelId: number;
  brandName?: string;
  modelName?: string;
  brandLogo?: string;
};

export type ButtonType = {
  variant: ButtonVariants;
  title: string;
  size: ButtonSizes;
  redirectUrl: string;
  icon?: string;
  filters: any;
};

export type SliderType = {
  widgetType: WIDGETS.Slider;
  list: SliderListType[];
  button?: ButtonType;
  title: string;
  subtitle: string;
};

export type NestedSliderListType = {
  button: ButtonType;
  list: SliderListType[];
};

export type NestedSliderType = {
  widgetType: WIDGETS.NestedSlider;
  carouselType: CarouselType;
  carouselList: string[];
  tabList: string[];
  title: string;
  subtitle: string;
  list: {
    [key: string]: NestedSliderListType;
  };
};

export type BrandListType = {
  image: string;
  redirectionUrl: string;
  title: string;
  filters: any;
};

export type BrandsType = {
  widgetType: WIDGETS.Brands;
  title: string;
  subtitle: string;
  button: ButtonType;
  list: BrandListType[];
};

export type FilterPopupDataList = {
  key?: string;
  title?: string;
  type: FilterListKeyType;
  value?: any;
  minValue?: {
    value: number;
    title: string;
  };
  maxValue?: {
    value: number;
    title: string;
  };
};

export type BannersList = {
  redirectionUrl : string;
  bannerUrl: string;
};

export type FilterPopupListType = {
  title: string;
  list: FilterPopupDataList[];
};

export type FilterPopupType = {
  widgetType: WIDGETS.FilterPopup;
  accordionList: string[];
  list: {
    [key: string]: FilterPopupListType;
  };
};

export type FooterType = {
  widgetType: WIDGETS.Footer;
  list: {
    image: string;
  };
};

export type CompareWidgetType = {
  widgetType: WIDGETS.CompareWidget;
  title: string;
  subtitle: string;
};

export type BannerWidgetType = {
  widgetType: WIDGETS.BannerWidget;
  banners: Array<BannersList>
};

export type LandingPageTypes =
  | HeaderType
  | SearchType
  | FilterType
  | SliderType
  | NestedSliderType
  | FilterPopupType
  | BrandsType
  | FooterType
  | CompareWidgetType
  | BannerWidgetType;

export type LandingPageType = LandingPageTypes[];
